import type {
  TimeSeriesPoint,
  TimeSeriesPointCustom
} from '@/features/_shared/chart/lib/buildChartLineSeries';
import type { SeriesData, SeriesRecord } from '@/features/_shared/chart/types/chartData';

export const parseSeasonalSeriesDataToSeries = ({
  series,
  field,
  decimalPlaces,
  timeRef,
  timezone
}: {
  series: SeriesData;
  field: string;
  decimalPlaces: number;
  timeRef: string;
  timezone: string;
}) => {
  switch (field) {
    case 'range': {
      return series.range.map((range, index) =>
        takeRangeData({ tsData: range, decimalPlaces, index, timeRef, timezone })
      );
    }
    case 'average': {
      return series.average.map((average, index) =>
        takeLineData({ tsData: average, decimalPlaces, index, timeRef, timezone })
      );
    }
    default: {
      const fieldData = (series as Partial<SeriesData>)[field];
      return fieldData?.map((tsData, index) => {
        return {
          ...takeLineData({ tsData, decimalPlaces, index, timeRef, timezone })
        };
      });
    }
  }
};
const takeLineData = ({
  tsData,
  decimalPlaces,
  index,
  timeRef,
  timezone
}: {
  tsData: SeriesRecord;
  decimalPlaces: number;
  index: number;
  timeRef?: string;
  timezone?: string;
}): TimeSeriesPoint => {
  const x = index;
  const y = Number(tsData[0]);
  const custom: TimeSeriesPointCustom = {
    decimalPlaces,
    ...(timeRef && { timeRef }),
    ...(timezone && { timezone }),
    ...(tsData.length > 1 && { transactionDate: tsData[1] as number | undefined })
  };
  return { x, y, custom };
};

const takeRangeData = ({
  tsData,
  decimalPlaces,
  index,
  timeRef,
  timezone
}: {
  tsData: SeriesRecord;
  decimalPlaces: number;
  index: number;
  timeRef: string;
  timezone: string;
}): TimeSeriesPoint => {
  const x = index;
  const low = Number(tsData[0]);
  const high = Number(tsData[1]);
  const custom: TimeSeriesPointCustom = {
    decimalPlaces,
    ...(timeRef && { timeRef }),
    ...(timezone && { timezone })
  };
  return { x, low, high, custom } as unknown as TimeSeriesPoint;
};
